import { type CommonTranslationFunction } from '@autone/translations';
import { type GenericGeneralFilterGroup } from '@autone/ui';
import { getFilterDimensionTranslations } from '@autone/utils';
import { type UnionToIntersection } from 'type-fest';

import {
  type AssortmentGeographicFilters,
  type AssortmentLocationClusterFilters,
  type AssortmentProductFilters,
  type AssortmentSkuFilters,
} from '../../../redux/assortment';

import { getReactKeyFromFilterOption } from './react-keys';

type AllFilterDimensions = keyof UnionToIntersection<
  | AssortmentProductFilters
  | AssortmentGeographicFilters
  | AssortmentLocationClusterFilters
  | AssortmentSkuFilters
>;

export const transformApiFiltersToGeneralFilterGroups = <
  F extends
    | AssortmentProductFilters
    | AssortmentGeographicFilters
    | AssortmentLocationClusterFilters
    | AssortmentSkuFilters,
>(
  filters: F,
  common: CommonTranslationFunction,
) => {
  type FilterIds = Extract<keyof F, string>;

  const translatedFilterDimensions: Record<AllFilterDimensions, string> =
    getFilterDimensionTranslations(common);
  const generalFilterGroups: GenericGeneralFilterGroup<FilterIds>[] = [];
  for (const [filterDimensionId, filterGroupOptions] of Object.entries(
    filters,
  )) {
    generalFilterGroups.push({
      id: filterDimensionId as FilterIds,
      translatedDisplayName:
        translatedFilterDimensions[
          filterDimensionId as keyof typeof translatedFilterDimensions
        ],
      options:
        filterGroupOptions?.map(({ id, description }) => ({
          id: getReactKeyFromFilterOption(id ?? '', description ?? ''),
          translatedDisplayName: description ?? id ?? '',
        })) ?? [],
    });
  }

  return generalFilterGroups;
};
